var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"steps-container separate--after"},[_c('ol',_vm._l((_vm.steps),function(step,index){return _c('li',{key:index,class:_vm.stepStyle(index),on:{"click":function($event){return _vm.stepChange(index)}}},[_vm._v(" "+_vm._s(step)+" ")])}),0)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }